import React, { useEffect } from 'react'
import useActivity from './useActivity'
import DataTable from 'app/componentV4/Table/DataTable'
import { useIntl } from 'react-intl'
import { getLocalizedDate } from 'commons/date'

const ActivityLogTab = ({ subscriberId }) => {
  const { formatMessage } = useIntl()
  const {
    state: { meta, isLoading, data },
    handleFetchActivity,
    updatePage,
  } = useActivity()

  useEffect(() => {
    handleFetchActivity({ subscriberId })
  }, [])
  return (
    <div className="space-y-5">
      <DataTable
        data={data}
        isCheckbox={false}
        columns={[
          {
            header: formatMessage({ id: 'activity.table.dateTime' }),
            accessor: 'createdAt',
            style: {
              minWidth: '150px',
              width: '250px',
              cursor: 'default',
            },
            render: (row) => {
              getLocalizedDate(row.createdAt)
            },
          },
          {
            header: formatMessage({ id: 'text.action' }),
            accessor: 'actionLog',
            style: {
              minWidth: '150px',
              cursor: 'default',
            },
            render: (row) => row.actionLog,
          },
        ]}
        pagination={meta}
        isLoading={isLoading}
        onFetch={(value) => updatePage({ ...value, subscriberId })}
      />
    </div>
  )
}

export default ActivityLogTab
